import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { ROLES } from '../model/user.model';
import { Route, ROUTES } from '../route/routes';
import { UserService } from '../service/user.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private userService: UserService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    let roles: ROLES[] = this.userService.getCurrentUserRoles();
    /*  let firstLanding: boolean = this.userService.isFirstLanding(); */
    let path = state.url;
    let can_activate = false;
    let route_obj = this.getRoute(route.routeConfig?.path!);

    if (this.userService.isExpiredToken) {
      console.warn("Auth token is expired");
      this.userService.logout(true);
    }
    /* if(firstLanding) {
      this.router.navigateByUrl(ROUTES.PRE_LANDING.absolute_path);
      return false;
    } */

    // console.log("ROLE", roles, "vuole accedere a", path);

    if (route_obj) {
      can_activate = roles ? this.canAccess(roles, route_obj[1]) : false;
    }

    // console.log("Can activate?", can_activate);

    if (!can_activate) {
      this.router.navigateByUrl(ROUTES.NOT_ALLOWED.absolute_path);
    }

    return can_activate;
  }

  private canAccess(roles: ROLES[], route: Route) {
    return route.roles.find(role => { return roles.includes(role) }) != undefined;
  }

  private getRoute(path: string) {
    path = '/' + path;
    return Object.entries(ROUTES).find(([key, value]) => { return value.absolute_path == path });
  }

}
